import { useFormContext, useWatch } from 'react-hook-form';

import { ClockControlInput } from '@features/tournament/ui/components/ClockControlInput/ClockControlInput';
import { AdditionalScoreInput } from '@features/tournament/ui/components/TournamentSettings/inputs/AdditonalScoreInput';
import { ArmageddonInput } from '@features/tournament/ui/components/TournamentSettings/inputs/ArmageddonInput';
import { EarlyFinishInput } from '@features/tournament/ui/components/TournamentSettings/inputs/EarlyFinishInput';
import { RoundDelaysInput } from '@features/tournament/ui/components/TournamentSettings/inputs/RoundDelaysInput';
import { SwissRoundsCount } from '@features/tournament/ui/components/TournamentSettings/inputs/SwissRoundsCount';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

import { SwissSeedInput } from './inputs/SwissSeedInput';
import { SwissSystemChangeInput } from './inputs/SwissSystemChangeInput';

export function SwissSettings() {
  const {
    control,
    setValue,
    formState: { disabled },
  } = useFormContext<TournamentEditFormValues>();

  const [mode, clockControl, clockControlSettings, roundsCount] = useWatch({
    name: ['mode', 'clockControl', 'clockControlSettingsPlayer1', 'swissSettings.roundsCount'],
    control,
  });

  return (
    <>
      <SwissSeedInput />

      <SwissRoundsCount />

      <EarlyFinishInput />

      <RoundDelaysInput maxRounds={roundsCount} />

      <ClockControlInput
        perPlayer={false}
        label="Контроль времени"
        value={{
          clockControl,
          clockControlSettings,
        }}
        onChange={({ clockControl, clockControlSettings }) => {
          setValue('clockControl', clockControl);
          setValue('clockControlSettingsPlayer1', clockControlSettings);
          setValue('clockControlSettingsPlayer2', clockControlSettings);
        }}
        disabled={disabled}
      />

      <AdditionalScoreInput />

      <ArmageddonInput
        disabled
        value={{
          armageddonEnabled: false,
          armageddonSettings: {
            clockControl: clockControl,
            clockControlSettingsPlayer1: clockControlSettings,
            clockControlSettingsPlayer2: clockControlSettings,
          },
        }}
        onChange={() => {}}
      />

      {mode === 'Private' && <SwissSystemChangeInput />}
    </>
  );
}
